import { Directive, HostListener, output, OutputEmitterRef, Signal, signal, WritableSignal } from '@angular/core';

/**
 * Ecoute le clavier sur toute la fenetre : emet chaque touche pressee et garde
 * l'etat des touches de modification, lisible par l'hote et ses descendants.
 */
@Directive({
  selector: '[appKeydown]',
})
export class Keydown {
  keyPressed: OutputEmitterRef<KeyboardEvent> = output<KeyboardEvent>();

  private readonly shift: WritableSignal<boolean> = signal(false);
  /** Ctrl sur Windows/Linux, Cmd sur Mac. */
  private readonly ctrlOrMeta: WritableSignal<boolean> = signal(false);
  readonly isShiftPressed: Signal<boolean> = this.shift.asReadonly();
  readonly isCtrlOrMetaPressed: Signal<boolean> = this.ctrlOrMeta.asReadonly();

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    this.syncModifiers(event);
    this.keyPressed.emit(event);
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent): void {
    this.syncModifiers(event);
  }

  /** Le keyup n'arrive jamais si la fenetre perd le focus touche enfoncee (Cmd + Tab). */
  @HostListener('window:blur')
  handleBlur(): void {
    this.shift.set(false);
    this.ctrlOrMeta.set(false);
  }

  private syncModifiers(event: KeyboardEvent): void {
    this.shift.set(event.shiftKey);
    this.ctrlOrMeta.set(event.ctrlKey || event.metaKey);
  }
}
